import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSearchLookUp = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 40 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M31 27L26.828 22.828",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M16 17H9",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeMiterlimit: 10,
			strokeLinecap: "square"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M16 23H9",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeMiterlimit: 10,
			strokeLinecap: "square"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M24 29H9",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeMiterlimit: 10,
			strokeLinecap: "square"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M24 11H9",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeMiterlimit: 10,
			strokeLinecap: "square"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M24 24C26.2091 24 28 22.2091 28 20C28 17.7909 26.2091 16 24 16C21.7909 16 20 17.7909 20 20C20 22.2091 21.7909 24 24 24Z",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeMiterlimit: 10,
			strokeLinecap: "square"
		})
	]
});
const ForwardRef = forwardRef(SvgSearchLookUp);
export default ForwardRef;
